import { DefaultTheme } from 'styled-components'
import { BarinetDark, BarinetLight } from './Barinet'
import { GuigoDark, GuigoLight } from './Guigotv'
import { HousenetDark, HousenetLight } from './Housenet'
import { LivetvDark, LivetvLight } from './Livetv'
import { MsfibraDark, MsfibraLight } from './Msfibra'
import { TurbolinkDark, TurbolinkLight } from './Turbolink'
import { VerofamiliaDark, VerofamiliaLight } from './Verofamilia'
import { WebfiberDark, WebfiberLight } from './Webfiber'

export type ThemeMode = 'light' | 'dark'
export type ThemeType = 'guigotv' | 'verofamilia' | 'barinet' | 'housenet' | 'livetv' | 'msfibra' | 'turbolink' | 'webfiber'

type IThemes = {
  [types in ThemeType]: {
    [modes in ThemeMode]: DefaultTheme
  }
}

const Themes: IThemes = {
  barinet: { light: BarinetLight, dark: BarinetDark },
  guigotv: { light: GuigoLight, dark: GuigoDark },
  housenet: { light: HousenetLight, dark: HousenetDark },
  livetv: { light: LivetvLight, dark: LivetvDark },
  msfibra: { light: MsfibraLight, dark: MsfibraDark },
  turbolink: { light: TurbolinkLight, dark: TurbolinkDark },
  verofamilia: { light: VerofamiliaLight, dark: VerofamiliaDark },
  webfiber: { light: WebfiberLight, dark: WebfiberDark },
}

export default Themes
